import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_PROMOTE_OR_SHARE_FACEBOOK_CTA_INTL = defineFcm('psf_promote_or_share_facebook_cta_intl')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'psf promote-or-share share slide-up',
		description:
			'Channel-aware CTA (Facebook, non-English markets, CHANGE-98792): kill-switch + experiment binding for the "Share to Facebook" primary button on the promote_or_share share slide-up. English locales already ship this productized via psf_promote_or_share_channel_aware_cta — enabling this config for one of them would enroll signers who already see the CTA, so keep the two locale sets disjoint.',
		template: {
			enabled: false,
			experimentName: 'psf_promote_or_share_facebook_cta_intl_experiment',
		},
	});
